import Icon from '../components/Icon.vue'

Icon.register({"yc":{"width":1536,"height":1792,"paths":[{"d":"M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 128v1536h-1536v-1536h1536z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/yc.js
// module id = 2007
// module chunks = 0